// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-30T17:48:37.698Z
// Property: Harrington Trail (ID: 6767906449167633)
// Collections: 4 amenities, 3 floorplans (live), 22 photos, 37 POIs, 5 reviews, 6 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167633",
  "property_external_id": "1661772",
  "property_zillow_url": "https://www.zillow.com/apartments/greenville-sc/harrington-trail/CgGtgN/",
  "property_apartments_url": null,
  "property_google_business_url": "https://www.google.com/maps/place/Harrington+Trail+-+a+Quinn+Residence/@34.7288644,-82.3543843,1881m/data=!3m1!1e3!4m6!3m5!1s0x885825712d4d9775:0xd5771b099a196bca!8m2!3d34.728743!4d-82.3556138!16s%2Fg%2F11mxj4_y_x?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57158638180",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "harrington-trail",
  "property_name": "Harrington Trail",
  "property_website_url": "https://www.harringtontrail.com",
  "property_domain": "https://www.harringtontrail.com",
  "property_address": "416 Pollyanna Drive",
  "property_full_address": "416 Pollyanna Dr, Greenville, SC 29605",
  "property_address_1": "416 Pollyanna Drive",
  "property_address_2": null,
  "property_address_city": "Greenville",
  "property_address_state": "SC",
  "property_address_zip_full": "29605",
  "property_address_zip": "29605",
  "property_address_country": "US",
  "property_address_county": "Greenville County",
  "property_neighborhood_address": null,
  "property_address_latitude": "34.72973",
  "property_address_longitude": "-82.353118",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(888) 416-8132",
  "property_call_tracking_phone": "888-416-8132",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Modern rental-home comfort with Greenville connections.</strong> Harrington Trail pairs spacious three- and four-bedroom layouts, fenced backyards, smart-home features, and included lawn maintenance with inviting community spaces—browse floor plans and find the home that fits how you live.</p>",
  "property_long_description": "<p><strong>Modern rental-home comfort with Greenville connections.</strong> At Harrington Trail, you get the space of a three- or four-bedroom home with the ease of a professionally maintained community. Choose from open layouts with granite countertops, stainless steel appliances, luxury flooring, smart-home technology, in-unit laundry, spacious closets, and a fenced backyard—then spend less time on upkeep thanks to included lawn maintenance.</p><p>Outside your door, an <a href=\"/amenities\">Olympic-size lap pool</a>, covered cabana, and fire pit patio create easy places to recharge. The Golden Grove setting puts you near the Michelin area and major Upstate routes, with Downtown Greenville, Mauldin, and Simpsonville all within a convenient drive. When you’re ready to explore, head toward Falls Park on the Reedy, the Swamp Rabbit Trail, the Greenville Zoo, the Peace Center, or Conestee Nature Preserve for the city’s signature mix of trails, dining, arts, and outdoor scenery. Browse <a href=\"/floor-plans\">three- and four-bedroom floor plans</a> and find the Greenville home that fits how you live.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior front view of a two-story house with a blue facade and brick accents, featuring a large garage door.",
    "public_id": "019fec29-a7af-72bb-b541-4455515d0ea1",
    "storage_key": "property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp",
    "width": 3072,
    "height": 2304
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167633/01a0c017-945d-727e-8377-b7d61c349212.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c017-945d-727e-8377-b7d61c349212",
    "storage_key": "property/6767906449167633/01a0c017-945d-727e-8377-b7d61c349212.mp4",
    "thumbnail_key": "property/6767906449167633/01a0c017-945d-727e-8377-b7d61c349212_thumb.webp",
    "size_bytes": 16191233,
    "classification": "Community",
    "title": "Discover Your New Home in a Beautiful Neighborhood",
    "description": "Explore this charming community featuring spacious homes, well-maintained streets, and abundant green spaces. Perfect for families and individuals seeking a peaceful and picturesque place to live."
  },
  "property_total_units": "77",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "0",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, bulk internet $65, landscaping $75, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://harringtontrail.securecafe.com/onlineleasing/harrington-trail/floorplans.aspx",
  "property_resident_portal_url": "https://harringtontrail.securecafenet.com/residentservices/harrington-trail/userlogin",
  "property_apply_now_url": "https://harringtontrail.securecafe.com/onlineleasing/harrington-trail/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/01a0cfb8-8901-74ca-be36-1e055ac0a1c9.webp",
  "property_primary_logo_media": {
    "alt_text": "Harrington Trail logo",
    "public_id": "01a0cfb8-8901-74ca-be36-1e055ac0a1c9",
    "storage_key": "property/6767906449167633/01a0cfb8-8901-74ca-be36-1e055ac0a1c9.webp",
    "width": 90,
    "height": 62
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/01a0cfbe-5fad-76b9-adc5-e4b4e0f3aed6.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0cfbe-5fad-76b9-adc5-e4b4e0f3aed6",
    "storage_key": "property/6767906449167633/01a0cfbe-5fad-76b9-adc5-e4b4e0f3aed6.webp",
    "width": 90,
    "height": 62
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/01a0cfbe-56d9-779b-b463-65f3cf45e742.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0cfbe-56d9-779b-b463-65f3cf45e742",
    "storage_key": "property/6767906449167633/01a0cfbe-56d9-779b-b463-65f3cf45e742.webp",
    "width": 90,
    "height": 62
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1d9446",
  "property_secondary_color": "#224f46",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2 - 2.5",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1548 - 1951",
  "property_sqft_min": "1548",
  "property_sqft_max": "1951",
  "property_price_range": "1575 - 2646",
  "property_price_min": "2010",
  "property_price_max": "2591",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/people/Harrington-Trail/100064277914466/",
  "property_instagram_url": "https://www.instagram.com/harringtontrail/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJdZdNLXElWIgRymsZmgkbd9U",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/harrington-trail-greenville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Harrington Trail",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Rental Home",
  "property_home_amenities_blurb": "<p><strong>Low-maintenance living, polished amenities.</strong> At Harrington Trail, rental-home comfort comes with standout spaces like an Olympic-size pool, covered cabana, and fire pit patio. Inside, smart-home features, in-unit laundry, stainless steel appliances, granite countertops, and luxury flooring add everyday ease—while handled lawn maintenance and available fenced backyards leave more time to enjoy the space around you.</p>",
  "property_home_floorplans_blurb": "<p><strong>Three- and four-bedroom rental homes, made easy to compare.</strong> Explore open, polished layouts at Harrington Trail, from the Brunswick to the Guilford and Kershaw. Granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and roomy closets bring style and function together, while select homes add fenced backyards for extra outdoor space.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Harrington Trail.</strong> Preview polished kitchens with stainless steel appliances and granite countertops, luxury flooring, spacious closets, and fenced backyards that extend your living space outdoors. Then browse community photos featuring a wide lap pool, shaded cabana seating, and a fire pit patio made for laid-back Greenville evenings.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Everyday Greenville, with more on the map.</strong> Harrington Trail’s Golden Grove location keeps errands close along Piedmont and West Georgia roads, with quick routes toward SCTAC/Donaldson Center, Augusta Road dining and boutiques, and weekend stops in West Greenville or the West End. From groceries to green spaces, it’s a low-key address with plenty to explore nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>See Harrington Trail through resident feedback.</strong><br>Browse real reviews and ratings for a clearer look at everyday life at this Greenville community—from the details that stand out after move-in to the questions worth asking before your tour.</p>",
  "property_neighborhood_blurb": "<p><strong>Start close to the everyday, then widen your map.</strong> From Harrington Trail’s Golden Grove setting, you’re positioned for low-key Greenville living with convenient access to area job centers, daily errands, and weekend detours. Head toward SCTAC/Donaldson Center for one of the Upstate’s aviation and advanced-manufacturing hubs, follow Augusta Road for boutiques, cafés, and dinner plans, or keep it simple with groceries and services along nearby Piedmont and West Georgia roads. When you want a change of pace, the map opens toward West Greenville’s studios and food spots, Fluor Field in the West End, and the green spaces that make the Upstate easy to explore. Use the interactive map to trace your usual routes, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Harrington Trail places home within reach of it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make home feel easier.</strong> Harrington Trail pairs the privacy of a rental home with polished shared spaces and low-maintenance convenience. Start the day with laps in the Olympic-size pool, unwind under the covered cabana, or settle in by the fire pit patio after dinner. Back at home, smart-home features, in-unit laundry, stainless steel appliances, granite countertops, and luxury flooring keep everyday routines feeling streamlined and refined.</p><p>With lawn maintenance handled and fenced backyards available, you can spend more time enjoying your space instead of managing upkeep. Explore the finishes, outdoor spaces, and community features in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Harrington Trail’s amenities support comfortable rental-home living in Greenville.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Harrington Trail.</strong> Choose a pet-friendly three- or four-bedroom home with high-end finishes, smart home features, and the ease of a maintenance-free lifestyle. Apply online today and take the next step toward loving where you LIVE.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Harrington Trail leasing team to learn more about our pet-friendly three- and four-bedroom homes in Greenville, get details on high-end finishes and smart-home features, or request directions to 416 Pollyanna Dr.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Harrington Trail?</strong> Find quick answers about the community, leasing, and everyday living in these pet-friendly three- and four-bedroom homes in Greenville. From high-end finishes to smart-home features and maintenance-free ease, this FAQ is here to help— and the leasing team is happy to answer anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits your day-to-day.</strong> Harrington Trail’s floor plans give you a focused lineup of three- and four-bedroom rental homes in Greenville, with layouts that feel open, polished, and easy to compare. Browse the Brunswick, Guilford, and Kershaw to find the bedroom count, bath setup, pricing, and availability that match what you need next.</p><p>Inside, details like granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and spacious closets add everyday function without losing style. Select a plan with a fenced backyard for extra outdoor breathing room, then check the cards below or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each home lives in person. For a closer look at finishes and shared spaces, explore the <a href=\"/gallery\">photo gallery</a>.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you tour.</strong> Harrington Trail’s gallery lets you move from polished interiors to open-air community spaces in a few scrolls. See bright kitchens with stainless steel appliances and granite countertops, living areas grounded by luxury flooring, and bedrooms with closets sized for real routines. Then step outside through the photos: a wide lap pool framed for sunny afternoons, shaded cabana seating, a fire pit patio ready for evening conversation, and fenced backyards that add another layer of usable space. Browse the views, compare how each layout feels, then continue to the <a href=\"/floor-plans\">floor plans</a> or take a closer look with <a href=\"/virtual-tours\">virtual tours</a> before you <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Harrington Trail on the map.</strong> Find available three- and four-bedroom homes in Greenville, then see how the community’s maintenance-free lifestyle, pet-friendly setting, and high-end home finishes fit into the surrounding area.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly space starts at your own back door.</strong> At Harrington Trail, select rental homes include fenced backyards that make quick outdoor breaks, fresh-air lounging, and after-walk wipe-downs feel simpler. Inside, easy-care finishes, spacious layouts, and in-unit laundry help keep daily pet routines running smoothly without giving up the polished feel of a modern home.</p><p>When it’s time for a bigger outing, Greenville offers nearby options for leashed walks and off-leash play, including Conestee Dog Park. Review the pet guidelines shown on this page, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Harrington Trail can fit life with your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Harrington Trail?</strong> Share the peace of mind, pet-friendly living, and maintenance-free comfort with friends. Invite them to discover three- and four-bedroom homes with high-end finishes, smart-home features, and the everyday ease of loving where they LIVE.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong> Log in to pay rent, submit maintenance requests, and manage your Harrington Trail account—so your maintenance-free lifestyle stays as effortless as the smart-home features and high-end finishes that make home feel easy.</p>",
  "property_reviews_blurb": "<p><strong>See Harrington Trail through residents’ eyes.</strong><br>As you browse the reviews and ratings below, you can get a practical sense of everyday life at Harrington Trail—from the details residents choose to highlight to the experiences that matter most after move-in. Use their feedback to compare expectations, gather questions for the leasing team, and decide what you’d like to see next at this Greenville community.</p>",
  "property_created_at": "1786373499177",
  "property_scheduletour_blurb": "<p><strong>See Harrington Trail in person.</strong> Tour pet-friendly three- and four-bedroom homes with high-end finishes, smart-home features, and the ease of a maintenance-free lifestyle. Explore available <a href=\"/floor-plans\">floor plans</a>, then schedule your visit to experience the peace of mind for yourself.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Harrington Trail.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture maintenance-free living in a pet-friendly Greenville community with three- and four-bedroom homes, high-end finishes, smart-home features, and the peace of mind that makes home feel just right.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the home before you visit.</strong> Harrington Trail’s virtual tours let you move through the Brunswick, Kershaw, and Guilford from wherever you are, so you can compare each layout at your own pace. Follow the flow from kitchen to living area, check bedroom placement, picture everyday storage in the closets, and notice the polished finishes—granite countertops, stainless steel appliances, and luxury flooring—that shape the look of these Greenville rental homes.</p><p>Use the tours to narrow your favorites, then compare current details on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Harrington Trail in person.</p>",
  "property_copyright": "© 2026 Quinn Residences. All rights reserved.",
  "property_seo_title_home": "Harrington Trail |  Apartments in Greenville, SC",
  "property_seo_description_home": "Discover luxury living at Harrington Trail, Greenville! Spacious homes with modern amenities, a lap pool, smart tech, and a cozy fire pit await.",
  "property_seo_title_floorplans": "Floor Plans | Greenville, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect space at Harrington Trail in Greenville! Choose from spacious three and four-bedroom floor plans designed for comfortable, modern living.",
  "property_seo_title_amenities": "Amenities | Greenville, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Harrington Trail in Greenville, SC! Enjoy a stunning Olympic-sized pool, smart-home features, and spacious designs. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Greenville, SC",
  "property_seo_description_gallery": "Discover luxury living at Harrington Trail, Greenville, SC! Enjoy spacious layouts, resort-style amenities, and smart-home features. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Harrington Trail Apartments",
  "property_seo_description_virtualtours": "Step into Harrington Trail in Greenville, SC. Experience spacious three and four-bedroom apartments in a vibrant community. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Harrington Trail Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Harrington Trail in Greenville, SC! Enjoy luxury amenities and a vibrant community. Explore our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Greenville, SC",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Greenville, SC at Harrington Trail. Dive into local favorites and explore nearby hotspots just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Harrington Trail",
  "property_seo_description_contact": "Connect with Harrington Trail in Greenville, SC! Inquire about our spacious three and four-bedroom floor plans. Your ideal home is just a question away!",
  "property_seo_title_faqs": "FAQs | Apartments in Greenville, SC",
  "property_seo_description_faqs": "Your questions answered at Harrington Trail in Greenville, SC! Dive into our FAQs to learn about spacious floor plans, luxury amenities, and smart living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Greenville, SC",
  "property_seo_description_reviews": "Join the Harrington Trail family in Greenville, SC! Enjoy spacious homes, luxury amenities, and a vibrant community. Check out what our residents love!",
  "property_seo_title_applynow": "Apply Now | Apartments in Greenville, SC",
  "property_seo_description_applynow": "Find your perfect home at Harrington Trail in Greenville, SC! Enjoy luxury amenities, spacious floor plans, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Harrington Trail",
  "property_seo_description_residentaccess": "Stay connected at Harrington Trail! Log in to the resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Harrington Trail",
  "property_seo_description_referafriend": "Refer a friend to Harrington Trail in Greenville, SC! Great friends make great neighbors—help them discover your vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Harrington Trail",
  "property_seo_description_scheduletour": "Experience the charm of Harrington Trail in Greenville, SC! Schedule your tour today and step into your new apartment paradise. Your dream home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Harrington Trail",
  "property_seo_description_privacy": "At Harrington Trail in Greenville, SC, privacy matters. Read our policy to understand how we protect your information while you enjoy your community.",
  "property_seo_title_accessibility": "Website Accessibility | Harrington Trail",
  "property_seo_description_accessibility": "At Harrington Trail in Greenville, SC, we prioritize digital inclusion, ensuring everyone can easily access information and connect with our community.",
  "property_seo_title_sitemap": "Sitemap | Harrington Trail",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Harrington Trail in Greenville, SC! Check out our sitemap for easy access to all features and amenities.",
  "property_seo_title_thankyou": "Thank You | Harrington Trail",
  "property_seo_description_thankyou": "Thank you for reaching out! A Harrington Trail team member will be in touch soon to guide you home to comfort and style in beautiful Greenville, SC.",
  "property_seo_title_pets": "Pet Policy | Apartments in Greenville, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793286822778",
  "amenities": [
    {
      "id": "ec_1348d1fe216ed9cde5260ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "120995522",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93cdf29fc98f18970bb32a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "120995517",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54bfaba21d99fdfb19abb877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "120995516",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6482fd2b5e883c2afae1730a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "120995521",
      "title": "Fire Pit Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_edb9b29ca3f769fad9fa9c1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp",
      "image_media": {
        "alt_text": "Exterior front view of a two-story house with a blue facade and brick accents, featuring a large garage door.",
        "public_id": "019fec29-a7af-72bb-b541-4455515d0ea1",
        "storage_key": "property/6767906449167633/019fec29-a7af-72bb-b541-4455515d0ea1.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "This inviting two-story home boasts a charming exterior with a mix of blue siding and classic brick accents, complemented by a spacious two-car garage.",
      "link": "false",
      "alt_text": "a house with a white garage door in front of it",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(10).jpg"
    },
    {
      "id": "ec_d4621e1058ba1ed3332e4c6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c1e8-72d9-8633-0126957ad072.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a garage and green lawn.",
        "public_id": "019fec29-c1e8-72d9-8633-0126957ad072",
        "storage_key": "property/6767906449167633/019fec29-c1e8-72d9-8633-0126957ad072.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Charming two-story home featuring a welcoming porch, attached garage, and a well-maintained lawn, perfect for comfortable living.",
      "link": "false",
      "alt_text": "a gray house with a garage and a driveway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(11).jpg"
    },
    {
      "id": "ec_51729eef6d25029a1642b098",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c352-77a9-a65d-3a3444516a70.webp",
      "image_media": {
        "alt_text": "Exterior front view of a single-family home with a garage.",
        "public_id": "019fec29-c352-77a9-a65d-3a3444516a70",
        "storage_key": "property/6767906449167633/019fec29-c352-77a9-a65d-3a3444516a70.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Charming single-family home with a two-car garage, perfect for any resident.",
      "link": "false",
      "alt_text": "a white house with a white garage door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(40).jpg"
    },
    {
      "id": "ec_4d5178542f6f067d4711cead",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c89e-71ff-acc3-02d262db5178.webp",
      "image_media": {
        "alt_text": "Exterior view of a white vinyl-sided apartment building with windows and a sliding glass door under a blue sky.",
        "public_id": "019fec29-c89e-71ff-acc3-02d262db5178",
        "storage_key": "property/6767906449167633/019fec29-c89e-71ff-acc3-02d262db5178.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Beautifully designed apartments with spacious exteriors and ample natural light. Enjoy the modern architecture and peaceful surroundings.",
      "link": "false",
      "alt_text": "a white house with white siding and a grassy yard",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(18).jpg"
    },
    {
      "id": "ec_368a9f18f8179126970a46e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-c91d-702a-a2b1-c198bff1b4d2.webp",
      "image_media": {
        "alt_text": "Exterior view of a townhome with light gray siding, multiple windows, and a sliding glass door.",
        "public_id": "019fec29-c91d-702a-a2b1-c198bff1b4d2",
        "storage_key": "property/6767906449167633/019fec29-c91d-702a-a2b1-c198bff1b4d2.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "This exterior view showcases a townhome with light gray siding. It features multiple windows and a sliding glass door, offering a glimpse of the private backyard space.",
      "link": "false",
      "alt_text": "a small white house with a open door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(38).jpg"
    },
    {
      "id": "ec_2b0fff3486af7a20317e06b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-d329-73c3-bd68-c4ed52e0e6bd.webp",
      "image_media": {
        "alt_text": "Rear exterior of a two-story apartment building with light gray siding and a small backyard.",
        "public_id": "019fec29-d329-73c3-bd68-c4ed52e0e6bd",
        "storage_key": "property/6767906449167633/019fec29-d329-73c3-bd68-c4ed52e0e6bd.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "View the rear exterior of this apartment building, featuring light gray siding and a spacious backyard perfect for outdoor activities.",
      "link": "false",
      "alt_text": "the back of a house with a yard in front of it",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(39).jpg"
    },
    {
      "id": "ec_36dfd6ade161539003cf6b21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-d97b-736f-ab86-dfa13b002583.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool, clubhouse, and playground at a multifamily property.",
        "public_id": "019fec29-d97b-736f-ab86-dfa13b002583",
        "storage_key": "property/6767906449167633/019fec29-d97b-736f-ab86-dfa13b002583.webp",
        "width": 1439,
        "height": 1079
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, modern clubhouse, and fun playground. Experience the best of community living.",
      "link": "false",
      "alt_text": "a large swimming pool in a neighborhood with a parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(3).jpg"
    },
    {
      "id": "ec_7b8366d82023098e9cd7c402",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-db55-7329-bf97-4456a0481857.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and community center at a residential property.",
        "public_id": "019fec29-db55-7329-bf97-4456a0481857",
        "storage_key": "property/6767906449167633/019fec29-db55-7329-bf97-4456a0481857.webp",
        "width": 1181,
        "height": 886
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our stunning outdoor swimming pool and well-appointed community center. Perfect for relaxation and recreation.",
      "link": "false",
      "alt_text": "a house and a swimming pool in front of a street",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(2).jpg"
    },
    {
      "id": "ec_9d9c8a8dfbb43d787695a280",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ea66-7223-9210-5f6ef1ebe462.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and a clubhouse.",
        "public_id": "019fec29-ea66-7223-9210-5f6ef1ebe462",
        "storage_key": "property/6767906449167633/019fec29-ea66-7223-9210-5f6ef1ebe462.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. The perfect spot to relax and unwind.",
      "link": "false",
      "alt_text": "a fence with a pool in front of a house",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(5).jpg"
    },
    {
      "id": "ec_f17a6f9d021fa0960f97d467",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f15f-752a-8498-253187281488.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and Adirondack chairs.",
        "public_id": "019fec29-f15f-752a-8498-253187281488",
        "storage_key": "property/6767906449167633/019fec29-f15f-752a-8498-253187281488.webp",
        "width": 3012,
        "height": 2259
      },
      "title": "Community",
      "description": "Gather around the fire pit in this communal outdoor seating area, perfect for relaxing and socializing with friends and neighbors.",
      "link": "false",
      "alt_text": "a fire pit with chairs around it on a patio",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(9).jpg"
    },
    {
      "id": "ec_380473d9aa5f88564ddffd69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-e60f-7265-bec5-9b640c92cc01.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019fec29-e60f-7265-bec5-9b640c92cc01",
        "storage_key": "property/6767906449167633/019fec29-e60f-7265-bec5-9b640c92cc01.webp",
        "width": 821,
        "height": 616
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our vibrant playground, perfect for children to play and explore.",
      "link": "false",
      "alt_text": "a playground with slides and a swing set",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(8).jpg"
    },
    {
      "id": "ec_3242046a8555340c3105e15c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-eb50-75c9-a6eb-c57f47e3612b.webp",
      "image_media": {
        "alt_text": "Harrington Residences monument sign with stone facade and landscaping",
        "public_id": "019fec29-eb50-75c9-a6eb-c57f47e3612b",
        "storage_key": "property/6767906449167633/019fec29-eb50-75c9-a6eb-c57f47e3612b.webp",
        "width": 821,
        "height": 616
      },
      "title": "Community",
      "description": "Welcome to Harrington Residences, a community featuring a beautiful stone monument sign with manicured landscaping.",
      "link": "false",
      "alt_text": "the sign for harrington cc in front of a house",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(19).jpg"
    },
    {
      "id": "ec_1ee25e1c00aa12c447c6fb1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-ef78-758f-bc87-caffcc4aa089.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with houses and streets.",
        "public_id": "019fec29-ef78-758f-bc87-caffcc4aa089",
        "storage_key": "property/6767906449167633/019fec29-ef78-758f-bc87-caffcc4aa089.webp",
        "width": 1439,
        "height": 1079
      },
      "title": "Community",
      "description": "An aerial perspective of a newly developed neighborhood, showcasing houses, manicured lawns, and curving streets.",
      "link": "false",
      "alt_text": "an aerial view of a group of houses and a street",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(1).jpg"
    },
    {
      "id": "ec_512c1024936aa0ff1bf5a9fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f174-758c-8a2f-77006409efc8.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban street lined with modern houses and manicured lawns.",
        "public_id": "019fec29-f174-758c-8a2f-77006409efc8",
        "storage_key": "property/6767906449167633/019fec29-f174-758c-8a2f-77006409efc8.webp",
        "width": 987,
        "height": 740
      },
      "title": "Community",
      "description": "Discover charming streetscapes with beautifully designed homes and lush landscaping, creating a welcoming neighborhood atmosphere.",
      "link": "false",
      "alt_text": "an aerial view of a neighborhood of houses with cars parked",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(4).jpg"
    },
    {
      "id": "ec_fdc36ceff41af43f01279459",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-f776-7459-a047-90e3c56be530.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fec29-f776-7459-a047-90e3c56be530",
        "storage_key": "property/6767906449167633/019fec29-f776-7459-a047-90e3c56be530.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with a double sink, granite countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "a kitchen with granite counter top and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(15).jpg"
    },
    {
      "id": "ec_63e997bd400be80fc40e155d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-fb09-7098-b412-46cb35ce8c01.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fec29-fb09-7098-b412-46cb35ce8c01",
        "storage_key": "property/6767906449167633/019fec29-fb09-7098-b412-46cb35ce8c01.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this fully equipped kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "a kitchen with white cabinets and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(14).jpg"
    },
    {
      "id": "ec_dc0760467617960550a2b10f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec29-fe50-76ae-b61f-8cfb9d158fdf.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with island and stainless steel appliances.",
        "public_id": "019fec29-fe50-76ae-b61f-8cfb9d158fdf",
        "storage_key": "property/6767906449167633/019fec29-fe50-76ae-b61f-8cfb9d158fdf.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area flows seamlessly into a modern kitchen featuring an island and stainless steel appliances.",
      "link": "false",
      "alt_text": "a renovated living room and kitchen with white walls and wood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(13).jpg"
    },
    {
      "id": "ec_e7a88dbdf248ded151a9e30d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2a-045a-7178-a3e3-4721c64022e8.webp",
      "image_media": {
        "alt_text": "Spacious living room with large windows and sliding glass doors leading to a backyard.",
        "public_id": "019fec2a-045a-7178-a3e3-4721c64022e8",
        "storage_key": "property/6767906449167633/019fec2a-045a-7178-a3e3-4721c64022e8.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy ample natural light and a seamless indoor-outdoor flow in this spacious living room. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "a renovated living room with hardwood floors and white walls",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(12).jpg"
    },
    {
      "id": "ec_ce13630028711140fc60eb12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2a-0cf3-77be-9a1a-f470d54a0c22.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living area and kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fec2a-0cf3-77be-9a1a-f470d54a0c22",
        "storage_key": "property/6767906449167633/019fec2a-0cf3-77be-9a1a-f470d54a0c22.webp",
        "width": 821,
        "height": 616
      },
      "title": "Apartment",
      "description": "Discover comfortable living in this open-concept apartment, featuring a modern kitchen with stainless steel appliances and granite countertops, flowing seamlessly into a spacious living area.",
      "link": "false",
      "alt_text": "an empty living room with hardwood floors and a kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(6).jpg"
    },
    {
      "id": "ec_8d7ed43c5fad0a5f4eef7adc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2a-0dec-7516-9774-ecdcfdc6b073.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows and a door leading to another room.",
        "public_id": "019fec2a-0dec-7516-9774-ecdcfdc6b073",
        "storage_key": "property/6767906449167633/019fec2a-0dec-7516-9774-ecdcfdc6b073.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious bedroom with large windows and wood-look flooring. Perfect for your personal oasis.",
      "link": "false",
      "alt_text": "a living room with white walls and wood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(16).jpg"
    },
    {
      "id": "ec_b589d60a8aa1eb5daf2df94e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2a-102d-7690-9f02-9edacb8093ad.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and toilet.",
        "public_id": "019fec2a-102d-7690-9f02-9edacb8093ad",
        "storage_key": "property/6767906449167633/019fec2a-102d-7690-9f02-9edacb8093ad.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with white countertops, a large mirror, and a separate toilet area. The dark wood-look flooring adds a touch of elegance.",
      "link": "false",
      "alt_text": "a white bathroom with two sinks and a toilet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(17).jpg"
    },
    {
      "id": "ec_e92c5372442f8caf17fcbc70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2a-1517-74d5-b459-23b9938cb0c7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity and open doorway to bedroom and shower.",
        "public_id": "019fec2a-1517-74d5-b459-23b9938cb0c7",
        "storage_key": "property/6767906449167633/019fec2a-1517-74d5-b459-23b9938cb0c7.webp",
        "width": 821,
        "height": 616
      },
      "title": "Apartment",
      "description": "Experience modern living in this stylish apartment bathroom, featuring a sleek vanity, spacious shower, and easy access to the bedroom.",
      "link": "false",
      "alt_text": "a white bathroom with a sink and a mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Harrington-Trail-Site-Manager%20(7).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2d3b71b4-d174-44e4-afbd-d02a001f4988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Blockhouse Restaurant and Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "1619 Augusta St, Greenville, SC 29605, USA",
      "poi_short_description": "Storied spot providing seafood, wood-grilled meat dishes & drinks, with catering & outdoor seating.",
      "poi_long_description": "Storied spot providing seafood, wood-grilled meat dishes & drinks, with catering & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-f45f-75ca-a65a-1b4ded2d1d39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-f45f-75ca-a65a-1b4ded2d1d39",
        "storage_key": "property/6767906449167633/019fec2b-f45f-75ca-a65a-1b4ded2d1d39.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://blockhouse.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11064816710158635656",
      "poi_item_slug": "blockhouse-restaurant-and-oyster-bar",
      "poi_latitude": "34.828862",
      "poi_longitude": "-82.399444",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-232-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SkoqzwwWIgRiNLPiSwgjpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ac8f05c9-0f92-45f7-8c19-4d354b2d2b9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "The Vista | Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2017A Augusta St, Greenville, SC 29605, USA",
      "poi_short_description": "Upscale-casual eatery serving familiar brunch, dinner and late-night eats (fish and seafood) and drinks.",
      "poi_long_description": "Upscale-casual eatery serving familiar brunch, dinner and late-night eats (fish and seafood) and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-f766-737c-ba89-21739b193e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-f766-737c-ba89-21739b193e74",
        "storage_key": "property/6767906449167633/019fec2b-f766-737c-ba89-21739b193e74.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thevistagvl.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7218312703041860564",
      "poi_item_slug": "the-vista--restaurant--bar",
      "poi_latitude": "34.8252749",
      "poi_longitude": "-82.3945718",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-365-2153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcw6DZhoxWIgR1PN_viiZLGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_20487de5-ec3d-4d3b-8e24-fce53cc17f82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "The Jones Oyster Co.",
      "poi_type": "Restaurants",
      "poi_address": "22 E Court St, Greenville, SC 29601, USA",
      "poi_short_description": "Lively locale with a bustling raw bar supplying oysters, lobster rolls, and other seafood-focused fare, plus cocktails.",
      "poi_long_description": "Lively locale with a bustling raw bar supplying oysters, lobster rolls, and other seafood-focused fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-eecf-71ab-98b1-1fe4296321be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-eecf-71ab-98b1-1fe4296321be",
        "storage_key": "property/6767906449167633/019fec2b-eecf-71ab-98b1-1fe4296321be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thejonesoysterco.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3732279663038944720",
      "poi_item_slug": "the-jones-oyster-co",
      "poi_latitude": "34.8482253",
      "poi_longitude": "-82.3993346",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-549-0301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY1eB3h4xWIgR0NXZPZS4yzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_24f1acd8-0ea1-4082-b47c-6d71b84bb952",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Soby's",
      "poi_type": "Restaurants",
      "poi_address": "207 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Reimagined Southern fare in airy, brick-walled environs, with a huge wine cellar.",
      "poi_long_description": "Reimagined Southern fare in airy, brick-walled environs, with a huge wine cellar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-efa8-75cf-8b81-285ba94da5fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-efa8-75cf-8b81-285ba94da5fa",
        "storage_key": "property/6767906449167633/019fec2b-efa8-75cf-8b81-285ba94da5fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://sobys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5010955766950205642",
      "poi_item_slug": "sobys",
      "poi_latitude": "34.84817779999999",
      "poi_longitude": "-82.3998694",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-232-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5QEf80xWIgRyhhDirh9ikU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_14f1f718-535a-443d-bd0e-44d89de6214e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Tupelo Honey Southern Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1 N Main St Ste t, Greenville, SC 29601, USA",
      "poi_short_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_long_description": "An all-day menu of Southern comfort food with a creative twist, plus craft beers & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-ee2d-7286-9cc9-253f7f333e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-ee2d-7286-9cc9-253f7f333e20",
        "storage_key": "property/6767906449167633/019fec2b-ee2d-7286-9cc9-253f7f333e20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tupelohoneycafe.com/restaurant/greenville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13469426920482742848",
      "poi_item_slug": "tupelo-honey-southern-kitchen--bar",
      "poi_latitude": "34.851653",
      "poi_longitude": "-82.3995296",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-451-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWoi49ExWIgRQCJ1i2sE7bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_acecc8cc-4a5b-4506-9cec-13c38a5d8e81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Summer Moon Coffee",
      "poi_type": "Restaurants",
      "poi_address": "409 Mills Ave #200, Greenville, SC 29605, USA",
      "poi_short_description": "Coffee shop on Mills Avenue in the Augusta Road area.",
      "poi_long_description": "Coffee shop on Mills Avenue in the Augusta Road area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-f3f5-74e9-89ff-ee851da18882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-f3f5-74e9-89ff-ee851da18882",
        "storage_key": "property/6767906449167633/019fec2b-f3f5-74e9-89ff-ee851da18882.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.summermooncoffee.com/locations/greenville-sc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7916260658633549402",
      "poi_item_slug": "summer-moon-coffee",
      "poi_latitude": "34.8270076",
      "poi_longitude": "-82.4094733",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-475-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2aaa-74f3-be7b-265cc5b1feab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-2aaa-74f3-be7b-265cc5b1feab",
        "storage_key": "property/6767906449167633/019fec2c-2aaa-74f3-be7b-265cc5b1feab.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ685DiqcxWIgRWqZAeyA13G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0ed2c744-4189-439c-ad2b-5e87cf7725d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Fork and Plough",
      "poi_type": "Restaurants",
      "poi_address": "1629 E North St, Greenville, SC 29607, USA",
      "poi_short_description": "Unfussy restaurant prepping farm-fresh brunch staples, meat dishes & seafood, plus cocktails & wine.",
      "poi_long_description": "Unfussy restaurant prepping farm-fresh brunch staples, meat dishes & seafood, plus cocktails & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-00d4-7537-a431-5b114820931c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-00d4-7537-a431-5b114820931c",
        "storage_key": "property/6767906449167633/019fec2c-00d4-7537-a431-5b114820931c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.forkandplough.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11111651918488721227",
      "poi_item_slug": "fork-and-plough",
      "poi_latitude": "34.8605313",
      "poi_longitude": "-82.3750128",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 864-732-6802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD1vNfzwuWIgRS9dOPYyENJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_99a006cf-7972-44bf-a0ee-6d2d592c164d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Passerelle Bistro",
      "poi_type": "Restaurants",
      "poi_address": "601 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Cozy spot for French meals, including Lyonnaise salad & steak frites, made with local ingredients.",
      "poi_long_description": "Cozy spot for French meals, including Lyonnaise salad & steak frites, made with local ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-f7e9-724c-b85d-5795d5ee5796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-f7e9-724c-b85d-5795d5ee5796",
        "storage_key": "property/6767906449167633/019fec2b-f7e9-724c-b85d-5795d5ee5796.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.passerelleinthepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700179041137738388",
      "poi_item_slug": "passerelle-bistro",
      "poi_latitude": "34.8449028",
      "poi_longitude": "-82.4016639",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 864-509-0142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-T5JDMwWIgRlEK0tHH1nYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_93def7fc-bc4e-4f8c-8876-463b3936942c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Grill Marks - Main St. Greenville",
      "poi_type": "Restaurants",
      "poi_address": "209 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Casual grill serving gourmet burgers, shakes and chicken entrees, plus fried pickles and sweet-potato fries.",
      "poi_long_description": "Casual grill serving gourmet burgers, shakes and chicken entrees, plus fried pickles and sweet-potato fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-faa6-7079-8a7c-dfd0595e5e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-faa6-7079-8a7c-dfd0595e5e95",
        "storage_key": "property/6767906449167633/019fec2b-faa6-7079-8a7c-dfd0595e5e95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.grillmarks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12421038465742534041",
      "poi_item_slug": "grill-marks---main-st-greenville",
      "poi_latitude": "34.8481254",
      "poi_longitude": "-82.3998872",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-233-5825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyJ2eM0xWIgRmfUL1KxkYKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f59b3527-1d21-4780-b295-2c2a533c37b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "The Lazy Goat",
      "poi_type": "Restaurants",
      "poi_address": "170 Riverplace, Greenville, SC 29601, USA",
      "poi_short_description": "Inspired Mediterranean small & large plates in an elegant riverside spot with open kitchen & patio.",
      "poi_long_description": "Inspired Mediterranean small & large plates in an elegant riverside spot with open kitchen & patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-fbba-729e-9ce2-5c6301226e22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-fbba-729e-9ce2-5c6301226e22",
        "storage_key": "property/6767906449167633/019fec2b-fbba-729e-9ce2-5c6301226e22.webp",
        "width": 960,
        "height": 642
      },
      "poi_business_url": "http://www.thelazygoat.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7535625608354670172",
      "poi_item_slug": "the-lazy-goat",
      "poi_latitude": "34.8465611",
      "poi_longitude": "-82.402574",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-679-5299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d72aced46058",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d72aced46058.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQJlvcwxWIgRXCZRupDrk2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_d387a1c4-be36-4988-a157-dfd607321bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "6 K-Mart Plaza, Greenville, SC 29605, USA",
      "poi_short_description": "Grocery chain carrying meats, plus fresh produce and seafood, along with a deli.",
      "poi_long_description": "Grocery chain carrying meats, plus fresh produce and seafood, along with a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-fe86-72c9-81ca-344def6baa6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-fe86-72c9-81ca-344def6baa6e",
        "storage_key": "property/6767906449167633/019fec2b-fe86-72c9-81ca-344def6baa6e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stores.foodlion.com/sc/greenville/6-k-mart-plz?y_source=1_MjI1NjA4MzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14013577300024844684",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.8191684",
      "poi_longitude": "-82.42002339999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 864-370-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd4-71d9-99f8-001f1d6cbde7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd4-71d9-99f8-001f1d6cbde7",
        "storage_key": "property/6767906449167633/019fec28-abd4-71d9-99f8-001f1d6cbde7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwWMWZMxWIgRjGF1qE46esI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fb8196de-73b2-45b2-9b37-929304dd1157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Pickwick Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3219 Augusta Rd, Greenville, SC 29605, USA",
      "poi_short_description": "Independent neighborhood pharmacy on Augusta Road.",
      "poi_long_description": "Independent neighborhood pharmacy on Augusta Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-03e2-725a-8525-ad43f028cfc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-03e2-725a-8525-ad43f028cfc6",
        "storage_key": "property/6767906449167633/019fec2c-03e2-725a-8525-ad43f028cfc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thepickwick.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4711906739645806738",
      "poi_item_slug": "pickwick-pharmacy",
      "poi_latitude": "34.8077227",
      "poi_longitude": "-82.3795227",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 864-277-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2ac4-7152-adca-7f2150c7af05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-2ac4-7152-adca-7f2150c7af05",
        "storage_key": "property/6767906449167633/019fec2c-2ac4-7152-adca-7f2150c7af05.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11UVqvsvWIgRknhbBzcOZEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_aff09b7e-e24a-46e7-bead-6485f39fcb7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2018 Augusta St, Greenville, SC 29605, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2b-ffb3-76b9-b13e-2ab7486fca11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2b-ffb3-76b9-b13e-2ab7486fca11",
        "storage_key": "property/6767906449167633/019fec2b-ffb3-76b9-b13e-2ab7486fca11.webp",
        "width": 1280,
        "height": 697
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2018+augusta+st-greenville-sc-29605/id=1252",
      "poi_directions_map_url": "https://maps.google.com/?cid=15651788001817237516",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.8243949",
      "poi_longitude": "-82.39528829999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 864-232-4781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8BvFSIwWIgRDJgJzEJSNtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_006fc059-d315-49d9-8d24-7126d7361fa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Haywood Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Haywood Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Sizable mall with shops for clothing, electronics & home goods, plus a range of dining options.",
      "poi_long_description": "Sizable mall with shops for clothing, electronics & home goods, plus a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-01f5-772a-9d86-d7439bf7dda9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-01f5-772a-9d86-d7439bf7dda9",
        "storage_key": "property/6767906449167633/019fec2c-01f5-772a-9d86-d7439bf7dda9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.simon.com/mall/haywood-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=5344190777624772756",
      "poi_item_slug": "haywood-mall",
      "poi_latitude": "34.8498312",
      "poi_longitude": "-82.33337759999999",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-288-0511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-d9adc204aaa1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-d9adc204aaa1",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-d9adc204aaa1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXxzrJeUuWIgRlEA-kDJhKko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5b5fd70e-c2b1-4e65-8855-5e0c46e9e743",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Robert E. Cashion Elementary School",
      "poi_type": "Education",
      "poi_address": "1500 Fork Shoals Rd, Greenville, SC 29605, USA",
      "poi_short_description": "Public elementary school, Greenville County Schools, on Fork Shoals Road.",
      "poi_long_description": "Public elementary school, Greenville County Schools, on Fork Shoals Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0456-751f-bf7a-d8fcfb319f5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0456-751f-bf7a-d8fcfb319f5f",
        "storage_key": "property/6767906449167633/019fec2c-0456-751f-bf7a-d8fcfb319f5f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.greenville.k12.sc.us/cashion/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7156515857010881391",
      "poi_item_slug": "robert-e-cashion-elementary-school",
      "poi_latitude": "34.7403358",
      "poi_longitude": "-82.3532211",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 864-355-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-ac10-743b-8f5a-4c76f79b9b9e",
        "storage_key": "property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFXzt5_AkWIgRb3OVTkENUWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_114f3f5c-9de5-404e-9d3b-51c57689bf92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Southside High School",
      "poi_type": "Education",
      "poi_address": "6630 Frontage Rd, Greenville, SC 29605, USA",
      "poi_short_description": "Public high school, Greenville County Schools, on Frontage Road.",
      "poi_long_description": "Public high school, Greenville County Schools, on Frontage Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-053a-76c6-85c6-89bfe25d7c84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-053a-76c6-85c6-89bfe25d7c84",
        "storage_key": "property/6767906449167633/019fec2c-053a-76c6-85c6-89bfe25d7c84.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "http://www.greenville.k12.sc.us/shs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1589108205927250032",
      "poi_item_slug": "southside-high-school",
      "poi_latitude": "34.7967846",
      "poi_longitude": "-82.40369489999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-355-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-ac10-743b-8f5a-4c76f79b9b9e",
        "storage_key": "property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_RaxKs6WIgRcLjza36lDRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a6f36c1a-b4cc-4243-8592-243f0aad713b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Greenville Technical College",
      "poi_type": "Education",
      "poi_address": "506 S Pleasantburg Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Two-year public technical college (Barton Campus) on South Pleasantburg Drive.",
      "poi_long_description": "Two-year public technical college (Barton Campus) on South Pleasantburg Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0770-702a-95bd-f331d8540113.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0770-702a-95bd-f331d8540113",
        "storage_key": "property/6767906449167633/019fec2c-0770-702a-95bd-f331d8540113.webp",
        "width": 1200,
        "height": 754
      },
      "poi_business_url": "https://www.gvltec.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5078691404558523632",
      "poi_item_slug": "greenville-technical-college",
      "poi_latitude": "34.8270773",
      "poi_longitude": "-82.37362639999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 864-250-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-ac10-743b-8f5a-4c76f79b9b9e",
        "storage_key": "property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJccT0kcYvWIgR8FyKpOwie0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a0053369-0faf-4281-9309-991b6c20e96d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Peace Center Concert Hall",
      "poi_type": "Entertainment",
      "poi_address": "300 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Touring musicians & resident theater troupes perform at this sizable, contemporary concert hall.",
      "poi_long_description": "Touring musicians & resident theater troupes perform at this sizable, contemporary concert hall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-07bd-7198-8dbb-7f4108f2720d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-07bd-7198-8dbb-7f4108f2720d",
        "storage_key": "property/6767906449167633/019fec2c-07bd-7198-8dbb-7f4108f2720d.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "http://www.peacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17197284789852293874",
      "poi_item_slug": "peace-center-concert-hall",
      "poi_latitude": "34.8475621",
      "poi_longitude": "-82.40110709999999",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-467-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodjBas0xWIgR8spfuGYHqe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e5970390-490d-4ccf-a022-0bfdb50b5391",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Bon Secours Wellness Arena",
      "poi_type": "Entertainment",
      "poi_address": "650 N Academy St, Greenville, SC 29601, USA",
      "poi_short_description": "Large indoor arena offering hockey & other sports events plus shows, rock music concerts & more.",
      "poi_long_description": "Large indoor arena offering hockey & other sports events plus shows, rock music concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0890-709d-9e33-32a797eeeeb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0890-709d-9e33-32a797eeeeb9",
        "storage_key": "property/6767906449167633/019fec2c-0890-709d-9e33-32a797eeeeb9.webp",
        "width": 1024,
        "height": 622
      },
      "poi_business_url": "http://bonsecoursarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602269140027816876",
      "poi_item_slug": "bon-secours-wellness-arena",
      "poi_latitude": "34.8526077",
      "poi_longitude": "-82.39152519999999",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 864-241-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJneQ4-dYxWIgRrLs5XwNB5K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_dad324a0-7d15-498e-b925-7cb9d9bf74c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Fluor Field",
      "poi_type": "Entertainment",
      "poi_address": "945 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Baseball stadium modeled after the Boston Red Sox's famed field, hosting minor-league ball games.",
      "poi_long_description": "Baseball stadium modeled after the Boston Red Sox's famed field, hosting minor-league ball games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-100c-736c-8754-520e6789f28c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-100c-736c-8754-520e6789f28c",
        "storage_key": "property/6767906449167633/019fec2c-100c-736c-8754-520e6789f28c.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://milb.com/greenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13620242211676828064",
      "poi_item_slug": "fluor-field",
      "poi_latitude": "34.8421855",
      "poi_longitude": "-82.4081831",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 864-240-4528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2abd-73cd-affe-629001d7cce1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-2abd-73cd-affe-629001d7cce1",
        "storage_key": "property/6767906449167633/019fec2c-2abd-73cd-affe-629001d7cce1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo7Q8sTUwWIgRoDHH3SDSBL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_21ced21c-166c-4900-9e44-17d4905680c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Falls Park on the Reedy",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Picturesque park with waterfall views, a curved suspension bridge & many acres of gardens.",
      "poi_long_description": "Picturesque park with waterfall views, a curved suspension bridge & many acres of gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-091c-74af-bf8d-24389ec83d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-091c-74af-bf8d-24389ec83d97",
        "storage_key": "property/6767906449167633/019fec2c-091c-74af-bf8d-24389ec83d97.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.greenvillesc.gov/167/Falls-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3467913960939550308",
      "poi_item_slug": "falls-park-on-the-reedy",
      "poi_latitude": "34.8449748",
      "poi_longitude": "-82.4015955",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 864-467-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd8-75a9-95b8-5073d9aaf8b2",
        "storage_key": "property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTkL5TIwWIgRZHZrqV-BIDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_62c4cc86-671c-48f3-ba7c-93770fcbbf44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "The Children’s Museum of the Upstate",
      "poi_type": "Entertainment",
      "poi_address": "300 College St, Greenville, SC 29601, USA",
      "poi_short_description": "Targeted at under-12 kids this large museum has multiple hands-on galleries plus camps & programs.",
      "poi_long_description": "Targeted at under-12 kids this large museum has multiple hands-on galleries plus camps & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-09d6-7018-9f8e-52cb61f002c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-09d6-7018-9f8e-52cb61f002c2",
        "storage_key": "property/6767906449167633/019fec2c-09d6-7018-9f8e-52cb61f002c2.webp",
        "width": 1280,
        "height": 1056
      },
      "poi_business_url": "https://tcmupstate.org/greenville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11902694258438889280",
      "poi_item_slug": "the-childrens-museum-of-the-upstate",
      "poi_latitude": "34.8558685",
      "poi_longitude": "-82.4004377",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 864-233-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2abc-735d-b24c-7cd74f717cfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-2abc-735d-b24c-7cd74f717cfa",
        "storage_key": "property/6767906449167633/019fec2c-2abc-735d-b24c-7cd74f717cfa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQmL8c8xWIgRQN9UaF3dLqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_72456323-24d9-4b1a-9e30-717eb2479815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Greenville County Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "420 College St, Greenville, SC 29601, USA",
      "poi_short_description": "Collection of art with Southern ties that range from 18th-century portraits to contemporary pieces.",
      "poi_long_description": "Collection of art with Southern ties that range from 18th-century portraits to contemporary pieces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0a31-77ad-beea-6dbf3e3f990c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0a31-77ad-beea-6dbf3e3f990c",
        "storage_key": "property/6767906449167633/019fec2c-0a31-77ad-beea-6dbf3e3f990c.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "http://www.gcma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18117121908921007326",
      "poi_item_slug": "greenville-county-museum-of-art",
      "poi_latitude": "34.8564081",
      "poi_longitude": "-82.40074159999999",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-271-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2abc-735d-b24c-7cd74f717cfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-2abc-735d-b24c-7cd74f717cfa",
        "storage_key": "property/6767906449167633/019fec2c-2abc-735d-b24c-7cd74f717cfa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1hbi88xWIgR3vyuNWPybPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_bca5133a-643b-4a8b-b2f2-b19aa9aad718",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Greenville Zoo",
      "poi_type": "Entertainment",
      "poi_address": "150 Cleveland Park Dr, Greenville, SC 29601, USA",
      "poi_short_description": "A global collection of mammals, reptiles & amphibians is on display at this small, no-frills zoo.",
      "poi_long_description": "A global collection of mammals, reptiles & amphibians is on display at this small, no-frills zoo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0bd0-73d1-908a-7e31bab5f8c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0bd0-73d1-908a-7e31bab5f8c8",
        "storage_key": "property/6767906449167633/019fec2c-0bd0-73d1-908a-7e31bab5f8c8.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.greenvillezoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436227881283834797",
      "poi_item_slug": "greenville-zoo",
      "poi_latitude": "34.8476002",
      "poi_longitude": "-82.3856309",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 864-467-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6IwACsuWIgRrVM3Vw3vry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_0871e088-b19d-498e-98e6-f0a7c6a22204",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Prisma Health Greenville Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "701 Grove Rd, Greenville, SC 29605, USA",
      "poi_short_description": "Greenville's largest hospital (Prisma Health), on Grove Road.",
      "poi_long_description": "Greenville's largest hospital (Prisma Health), on Grove Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0cfc-77a8-a777-8e7dfc68999b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0cfc-77a8-a777-8e7dfc68999b",
        "storage_key": "property/6767906449167633/019fec2c-0cfc-77a8-a777-8e7dfc68999b.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://prismahealth.org/locations/hospitals/greenville-memorial-hospital?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5598622282899715788",
      "poi_item_slug": "prisma-health-greenville-memorial-hospital",
      "poi_latitude": "34.8187964",
      "poi_longitude": "-82.41293329999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-455-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd1-75a5-90a2-d2c24605c03d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd1-75a5-90a2-d2c24605c03d",
        "storage_key": "property/6767906449167633/019fec28-abd1-75a5-90a2-d2c24605c03d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_Tqq2swWIgRzPbSs01Nsk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_e265d253-abc6-4f6c-ab1c-f51f563fbe8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "AFC Urgent Care Bon Secours - Augusta Road",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 Augusta Rd Ste b, Greenville, SC 29605, USA",
      "poi_short_description": "Walk-in urgent care clinic on Augusta Road for minor illnesses, injuries and lab work.",
      "poi_long_description": "Walk-in urgent care clinic on Augusta Road for minor illnesses, injuries and lab work.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-0ee8-72ab-9458-9bb63da0bbc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-0ee8-72ab-9458-9bb63da0bbc4",
        "storage_key": "property/6767906449167633/019fec2c-0ee8-72ab-9458-9bb63da0bbc4.webp",
        "width": 696,
        "height": 479
      },
      "poi_business_url": "https://www.afcurgentcare.com/augusta-road/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-augusta-road-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9219631947795659079",
      "poi_item_slug": "afc-urgent-care-bon-secours---augusta-road",
      "poi_latitude": "34.8271342",
      "poi_longitude": "-82.39815159999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-412-7812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YUUPCMwWIgRR_kzqGi28n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_153cfe09-c879-46e4-9fde-ce21503cd754",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Catalyst Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Laurens Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Gym with free weights, specialized machines, and cardio equipment, as well as trainers.",
      "poi_long_description": "Gym with free weights, specialized machines, and cardio equipment, as well as trainers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-1645-77db-b21d-5d91db57213d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-1645-77db-b21d-5d91db57213d",
        "storage_key": "property/6767906449167633/019fec2c-1645-77db-b21d-5d91db57213d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.catalystgreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14866435803533491912",
      "poi_item_slug": "catalyst-gym",
      "poi_latitude": "34.8500267",
      "poi_longitude": "-82.3758612",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_LHjzEuWIgRyD7D-ZgwUM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0895c24e-23b8-40c0-bf77-86eb5eadc4e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Conestee Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 Mauldin Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Home to more than 200 bird species, this 400-acre wildlife preserve offers paved trails & bog walks.",
      "poi_long_description": "Home to more than 200 bird species, this 400-acre wildlife preserve offers paved trails & bog walks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-9531-7428-8100-157ee8a9c4c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec28-9531-7428-8100-157ee8a9c4c9",
        "storage_key": "property/6767906449167633/019fec28-9531-7428-8100-157ee8a9c4c9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://conesteepreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14514418562035381221",
      "poi_item_slug": "conestee-nature-preserve",
      "poi_latitude": "34.7751711",
      "poi_longitude": "-82.3546277",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 864-277-2004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd8-75a9-95b8-5073d9aaf8b2",
        "storage_key": "property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7wiqBUlWIgR5XN0D8iSbck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_b597f190-ae3c-4abc-b1f1-a63c5f3b4210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Conestee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 Mauldin Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Family-friendly recreational space featuring ballfields, picnic tables, dog parks and an array of trails.",
      "poi_long_description": "Family-friendly recreational space featuring ballfields, picnic tables, dog parks and an array of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-9b57-73ff-851e-da231851fc91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec28-9b57-73ff-851e-da231851fc91",
        "storage_key": "property/6767906449167633/019fec28-9b57-73ff-851e-da231851fc91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://greenvillerec.com/parks/conestee-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14327331757995132035",
      "poi_item_slug": "conestee-park",
      "poi_latitude": "34.7799888",
      "poi_longitude": "-82.3512721",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 864-387-0265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd8-75a9-95b8-5073d9aaf8b2",
        "storage_key": "property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZFukXQlWIgRgwR5DlPo1MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_586c211f-0648-42d7-aa18-e40bb0b0e034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "7th Inning Splash Park",
      "poi_type": "Entertainment",
      "poi_address": "1500 Piedmont Hwy, Piedmont, SC 29673, USA",
      "poi_short_description": "Baseball-themed water park, featuring a pool for swimming, slides and a splash pad, along with playground equipment.",
      "poi_long_description": "Baseball-themed water park, featuring a pool for swimming, slides and a splash pad, along with playground equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-844c-7292-9e1b-0f200f336330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec28-844c-7292-9e1b-0f200f336330",
        "storage_key": "property/6767906449167633/019fec28-844c-7292-9e1b-0f200f336330.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://waterparks.greenvillerec.com/7th-inning-splash/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6541392283271213099",
      "poi_item_slug": "7th-inning-splash-park",
      "poi_latitude": "34.773707",
      "poi_longitude": "-82.430183",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-299-1842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7aP4Pc6WIgRK7DctJ-xx1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_c5899720-40ff-4409-ae9b-05f02cb791e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Cleveland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Cleveland Park Dr & East Washington, Greenville, SC 29601, USA",
      "poi_short_description": "Venerable urban park on 122 acres with a fitness trail, picnic shelters & tennis/volleyball courts.",
      "poi_long_description": "Venerable urban park on 122 acres with a fitness trail, picnic shelters & tennis/volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-1703-7502-ae6b-cb70f8e616b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-1703-7502-ae6b-cb70f8e616b5",
        "storage_key": "property/6767906449167633/019fec2c-1703-7502-ae6b-cb70f8e616b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillesc.gov/1581/Cleveland-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4739581147201544383",
      "poi_item_slug": "cleveland-park",
      "poi_latitude": "34.8493214",
      "poi_longitude": "-82.38468519999999",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 864-467-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd8-75a9-95b8-5073d9aaf8b2",
        "storage_key": "property/6767906449167633/019fec28-abd8-75a9-95b8-5073d9aaf8b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-bRTNUvWIgRvyAWJ_FfxkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c696125d-9786-4d2f-bd72-9ed3f6f74e4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Greenlink Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 W McBee Ave, Greenville, SC 29601, USA",
      "poi_short_description": "Downtown hub for Greenlink, Greenville's public bus system, on West McBee Avenue.",
      "poi_long_description": "Downtown hub for Greenlink, Greenville's public bus system, on West McBee Avenue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-1a9d-7590-9ecd-4a1b8648a388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-1a9d-7590-9ecd-4a1b8648a388",
        "storage_key": "property/6767906449167633/019fec2c-1a9d-7590-9ecd-4a1b8648a388.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillesc.gov/151/Greenlink-Transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=3801114405955517666",
      "poi_item_slug": "greenlink-transit-center",
      "poi_latitude": "34.8501054",
      "poi_longitude": "-82.4007771",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 864-467-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZ4EoDUwWIgR4jyZvWlFwDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_6852862f-fea5-44a1-9984-9c7244964e37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Greenville-Spartanburg International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 GSP Dr, Greer, SC 29651, USA",
      "poi_short_description": "Airport serving the Southeast & offering free WiFI plus conference rooms & snack bars.",
      "poi_long_description": "Airport serving the Southeast & offering free WiFI plus conference rooms & snack bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-23ef-741f-83ad-c859ca6d66a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-23ef-741f-83ad-c859ca6d66a7",
        "storage_key": "property/6767906449167633/019fec2c-23ef-741f-83ad-c859ca6d66a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gspairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592584854167939865",
      "poi_item_slug": "greenville-spartanburg-international-airport",
      "poi_latitude": "34.8959008",
      "poi_longitude": "-82.2172338",
      "poi_miles_from_property": "19.9 mi",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 864-877-7426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abc4-733f-a7f6-df8e3ee62e1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abc4-733f-a7f6-df8e3ee62e1e",
        "storage_key": "property/6767906449167633/019fec28-abc4-733f-a7f6-df8e3ee62e1e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfjLOQoqWIgRGevoSEvanE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_91cd33e8-706a-429c-952a-a4b67186ec7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Clemson University International Center for Automotive Research (CU-ICAR)",
      "poi_type": "Education",
      "poi_address": "5 Research Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Clemson University's automotive research campus and graduate engineering center on Research Drive.",
      "poi_long_description": "Clemson University's automotive research campus and graduate engineering center on Research Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-98e7-7214-8de2-88698db460bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec28-98e7-7214-8de2-88698db460bc",
        "storage_key": "property/6767906449167633/019fec28-98e7-7214-8de2-88698db460bc.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://cuicar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3707318036026301668",
      "poi_item_slug": "clemson-university-international-center-for-automotive-research-cu-icar",
      "poi_latitude": "34.8142542",
      "poi_longitude": "-82.327236",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-283-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-ac10-743b-8f5a-4c76f79b9b9e",
        "storage_key": "property/6767906449167633/019fec28-ac10-743b-8f5a-4c76f79b9b9e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8FdzGsvWIgR5By_jhwKczM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_83398dbb-4935-49a9-acab-30ac010de975",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Michelin North America Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Parkway S, Greenville, SC 29615, USA",
      "poi_short_description": "North American headquarters of the tire maker, on Parkway South off Pelham Road.",
      "poi_long_description": "North American headquarters of the tire maker, on Parkway South off Pelham Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-2265-7319-9948-ac0714f7103e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-2265-7319-9948-ac0714f7103e",
        "storage_key": "property/6767906449167633/019fec2c-2265-7319-9948-ac0714f7103e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.michelinman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1897357148203265553",
      "poi_item_slug": "michelin-north-america-headquarters",
      "poi_latitude": "34.8609544",
      "poi_longitude": "-82.2581886",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-458-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdV9YnUpWIgRES60DkbEVBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_648bdfa5-498e-452c-a8d2-b4d61f46a129",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "Fluor Enterprises, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Fluor Daniel Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Global engineering and construction firm; a major Greenville employer on Fluor Daniel Drive.",
      "poi_long_description": "Global engineering and construction firm; a major Greenville employer on Fluor Daniel Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-24b4-751c-85ba-9862975e8e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-24b4-751c-85ba-9862975e8e0a",
        "storage_key": "property/6767906449167633/019fec2c-24b4-751c-85ba-9862975e8e0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fluor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7805122715444489415",
      "poi_item_slug": "fluor-enterprises-inc",
      "poi_latitude": "34.844653",
      "poi_longitude": "-82.334351",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 864-281-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2zSquIuWIgRx6xmosFdUWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_6e2cd4f2-794e-4af4-b25c-5f3035cd1e83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "custom",
      "poi_name": "GE Vernova - Gas Turbine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Garlington Rd, Greenville, SC 29615, USA",
      "poi_short_description": "Gas turbine manufacturing campus on Garlington Road; one of Greenville's largest industrial employers.",
      "poi_long_description": "Gas turbine manufacturing campus on Garlington Road; one of Greenville's largest industrial employers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec2c-22ca-72bb-9e2c-5752293a171a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-22ca-72bb-9e2c-5752293a171a",
        "storage_key": "property/6767906449167633/019fec2c-22ca-72bb-9e2c-5752293a171a.webp",
        "width": 1280,
        "height": 683
      },
      "poi_business_url": "http://www.ge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1984861977925348760",
      "poi_item_slug": "ge-vernova---gas-turbine",
      "poi_latitude": "34.8325103",
      "poi_longitude": "-82.28609490000001",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-254-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec28-abd2-779a-8dc8-0cea19fc85cb",
        "storage_key": "property/6767906449167633/019fec28-abd2-779a-8dc8-0cea19fc85cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHT6PC9ooWIgRmG1r4nOlixs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e6f32b0f5cd11e5e9cea5012",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f60ac212e8847859a8da324e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_21735bf698d407fa71f5680c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_24a2c09be44b03418323b71e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6876a85efceb58f6e38f4f25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b2d1a4d8aabfed7e26106595",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_5321102cb8c69e859d54bc72",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "rating": "5",
      "name": "Tamara Stubbs",
      "text": "We moved to this neighborhood from downtown Greenville in January.  Ashley was very helpful with the application/move in process and quickly answered/responded to all questions.  She was a pleasure to work with!  Maintenance requests have been addressed quickly.  Seth has been very helpful answering questions and making sure all concerns have been addressed.  I would definitely recommend this neighborhood!",
      "date": "2026-03-08",
      "title": "false"
    },
    {
      "id": "ec_8cda00bb79aacee1fb8ddb1e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "rating": "5",
      "name": "Ayana Tucker",
      "text": "Staying in Harrington Trail has been a pleasant experience. I was greeted by the staff with a warm welcome. All of my neighbors are so friendly. The homes are amazing and a breath of fresh air. The maintenance teams handles all of my concerns professionally with a sense of urgency! I'm so glad I moved to this community!",
      "date": "2026-03-09",
      "title": "false"
    },
    {
      "id": "ec_150754dd31fae09a5c17be9b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "rating": "5",
      "name": "Kathy Loftus",
      "text": "We are only here 9 days so far. We love the home. The staff has been awesome. Ashley really helped us with the application process, as we had a little difficulty with it. We are so looking forward to the pool this summer. I have heard many good things from our neighbors about how friendly people on the community are. We are hoping to be able to call Harrington Trails home for a long time. Come visit the available homes.",
      "date": "2026-02-23",
      "title": "false"
    },
    {
      "id": "ec_c738114e77e2ea7459f844f3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "rating": "4",
      "name": "Jordan Langan",
      "text": "Since Quinn has taken over in terms of property management, there has been a better rate and quality of response when it comes to maintaining homes, the pool and communal areas, and the neighborhood itself. A safe, quiet place to live. We have been here for 3 years and have enjoyed our time here!",
      "date": "2026-02-23",
      "title": "false"
    },
    {
      "id": "ec_69768bb830f125de4d0ff09b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "rating": "5",
      "name": "Jessica Infante",
      "text": "We enjoy living in Harrignton! We moved here a few months ago and we have adjusted well, the community is very calm and family friendly. The park and pool is a plus. The process to rent was easy and had fast communication, also very friendly staff.",
      "date": "2026-03-07",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_93359442-165c-49eb-a234-293ae162b2b4",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_f9c90a98-05b2-42b9-a1ba-72321645ca8e",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_1c8ca2dc-0184-4bca-92fe-55b4d09cc989",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_ff78b59c-ed97-4509-9522-304aa3db6da0",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_930f23be-c58a-4de9-92ff-40a04803a80a",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_47c0f545-9985-455d-a6d6-738d52c14fd3",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b43552e8-1d3f-407d-8089-62752200b171",
      "question": "Landscape Services",
      "answer": "Single-family homes: $75/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_ba6422e1-cc7a-464b-8c43-7f6f5787030f",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_0fac46c7-97df-4700-ac80-a0934a2f76bb",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_431c3362-f50c-46e3-bb11-64751ce92684",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_dac3c475-9cbd-43bd-b68d-1d18cf72677a",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_686bdda2-1724-4636-9e25-076b132c750a",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_8fa66352-f381-43e7-8dda-d5f605122dd0",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_1696516b-b866-4ba6-9c64-6f0ab3f72f89",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_2376d6fa-8207-44e3-83d7-6cc71803cecd",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_49418c74-7a67-45d7-bdcb-e0da05c7218c",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_d87a11c5-05cc-4c80-b377-1c1e8df42aee",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_026e6ea2-aa53-4e91-adb7-0ea336ee0454",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_325ec007-5816-44bc-b67f-d1ba0c89a210",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_46121094cad2a9a3e00ee2ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "2337368",
      "pet_type": "all",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_9ff8c3686aff96b4750acd24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "2337364",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_9acac3065fefc50b99deff19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "yardi",
      "external_id": "2337366",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-95c7-73e7-89e4-95c1abf62e46",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Harrington Trail Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633"
    },
    {
      "lead_collector_id": "01a0abe0-964a-70ae-bc1b-f13858651192",
      "lead_source": "LANDING_PAGE",
      "name": "Harrington Trail Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-greenville-sc",
      "search_query": "luxury apartments with in‑unit laundry Greenville SC",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience luxury living in Greenville SC with in-unit laundry. Discover the elegant features at Harrington Trail designed for your lifestyle.",
      "page_copy": "Welcome to Harrington Trail, where luxury meets convenience in the heart of Greenville, SC. Our stunning apartment homes are designed with modern comforts, including the sought-after in-unit laundry feature. Imagine the ease and comfort of having laundry facilities right in your home, saving you time and enhancing your living experience.\n\nIn addition to our in-unit laundry, Harrington Trail showcases other premier amenities such as a fenced backyard, stainless steel appliances, and spacious closets. Nestled in a vibrant community with a playground and a security deposit alternative, our luxury apartments offer everything you need for a comfortable and refined lifestyle. Come explore what makes Harrington Trail the perfect choice for upscale living in Greenville, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore luxury apartments in Greenville SC with in-unit laundry at Harrington Trail. Enjoy modern amenities like a playground and spacious closets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartments-with-olympic-size-pool-greenville-county",
      "search_query": "apartments with Olympic size pool in Greenville County",
      "category": "Amenity",
      "h1_title": "Apartments with Olympic Size Pool",
      "h2_subtitle": "Discover exceptional living with an Olympic size pool in Greenville County. Harrington Trail offers luxurious amenities in a welcoming community.",
      "page_copy": "Welcome to Harrington Trail, where unique amenities elevate your lifestyle in Greenville County. While our community does not currently feature an Olympic size pool, we provide a wide range of luxurious features that cater to all your needs. Enjoy stainless steel appliances and spacious closets, perfect for residents who appreciate modern conveniences.\n\nOur family-friendly environment includes a playground and innovative security deposit alternatives, ensuring a hassle-free transition to upscale living. The fenced backyard offers a private retreat, making Harrington Trail an excellent choice for those seeking comfort and style in Greenville County. We invite you to explore the superior living experience offered here, even in the absence of an Olympic size pool.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Olympic Size Pool",
      "seo_description": "Explore apartments in Greenville County with premium amenities at Harrington Trail. Discover the perfect balance of comfort and style in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "smart-home-luxury-apartments-greenville-29605",
      "search_query": "smart-home luxury apartments in Greenville 29605",
      "category": "Amenity",
      "h1_title": "Smart-Home Luxury Apartments in Greenville",
      "h2_subtitle": "Experience smart-home living in Greenville's 29605 area. Harrington Trail offers cutting-edge features and unparalleled luxury.",
      "page_copy": "Welcome to Harrington Trail, the epitome of modern luxury living in the Greenville 29605 area. While our apartments are not specifically designated as smart homes, they provide a range of high-end features that embody comfort and style. From stainless steel appliances to spacious closets, our homes are designed to accommodate a contemporary lifestyle.\n\nEnjoy the practicality of a security deposit alternative alongside family-friendly amenities, such as a playground and fenced backyard. Our luxury apartments are nestled in a thriving community, ready to offer you an exceptional living experience. Discover what makes Harrington Trail the perfect place to call home, where comfort meets sophistication in Greenville, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Luxury Apartments in Greenville",
      "seo_description": "Find luxury living with smart-home features in Greenville's 29605 at Harrington Trail. Enjoy modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "greenville-apartments-granite-countertops",
      "search_query": "Greenville apartments with granite countertops",
      "category": "Amenity",
      "h1_title": "Greenville Apartments with Granite Countertops",
      "h2_subtitle": "Discover Greenville living with sleek granite countertops. Harrington Trail offers stylish and comfortable homes with premium features.",
      "page_copy": "At Harrington Trail, you can indulge in the elegance and durability of granite countertops, perfectly suited for those who appreciate modern design in Greenville. Although our apartments feature stainless steel appliances and numerous luxury amenities, the charm of granite countertops adds a touch of sophistication that complements any interior style.\n\nOur community is designed to enhance your living experience with amenities like spacious closets, a fenced backyard, and a playground. Conveniently located within the vibrant area of Greenville, SC, Harrington Trail ensures a comfortable lifestyle with beneficial extras such as a security deposit alternative. Experience unparalleled convenience and style by making Harrington Trail your new home today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenville Apartments with Granite Countertops",
      "seo_description": "Explore Harrington Trail in Greenville SC, offering luxury apartments with granite countertops and modern amenities. Experience stylish living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "spacious-closet-apartments-greenville",
      "search_query": "spacious closet apartments near Greenville",
      "category": "Amenity",
      "h1_title": "Spacious Closet Apartments Near Greenville",
      "h2_subtitle": "Find the perfect home with generous closet space near Greenville. Harrington Trail offers modern luxury and ample storage solutions.",
      "page_copy": "Welcome to Harrington Trail, where spacious closets are just one of the many features that make our apartments near Greenville a top choice. With an emphasis on providing ample storage, our homes cater to residents who value organization and easy access to their belongings.\n\nBeyond spacious closets, our community offers a range of amenities tailored for modern living. Stainless steel appliances and a fenced backyard enhance everyday life, while a playground and security deposit alternative provide added convenience. Embrace the comfort and style of Harrington Trail, ideally located near the vibrant heart of Greenville, SC, and discover a place where thoughtful design meets practical luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closet Apartments Near Greenville",
      "seo_description": "Discover spacious closet apartments near Greenville at Harrington Trail, featuring modern amenities and ample storage in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-greenville-sc",
      "search_query": "three bedroom apartments greenville sc",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Greenville, SC",
      "h2_subtitle": "Explore spacious three-bedroom living at Harrington Trail in Greenville, SC. Enjoy modern amenities in a family-friendly community.",
      "page_copy": "Discover the ideal setting for family life or shared living at Harrington Trail, offering three-bedroom apartments in the welcoming city of Greenville, SC. Our homes are thoughtfully designed to provide ample space and comfort, accommodating all your lifestyle needs.\n\nEach apartment features stainless steel appliances, spacious closets, and a fenced backyard, ensuring a blend of style and practicality. Families will appreciate the onsite playground, while everyone benefits from the security deposit alternative. Experience a perfect mix of modern amenities and convenience in a vibrant community, all nestled in the beautiful surroundings of Greenville, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Greenville, SC",
      "seo_description": "Find spacious three-bedroom apartments in Greenville, SC at Harrington Trail, with modern amenities and family-friendly features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-near-29605",
      "search_query": "four bedroom apartments near 29605",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments Near 29605",
      "h2_subtitle": "Discover expansive four-bedroom living at Harrington Trail, conveniently situated near the 29605 area, offering a range of premium amenities.",
      "page_copy": "Explore the comfort of four-bedroom apartments near the 29605 zip code at Harrington Trail. Our spacious homes are ideal for families and roommates seeking ample living space in a convenient location. Each apartment is designed with modern living in mind, featuring open layouts and luxurious amenities.\n\nResidents enjoy stainless steel appliances, spacious closets, and a fenced backyard, enhancing privacy and ease of living. Families will appreciate the playground, while the security deposit alternative offers flexible leasing options. Located just a short drive from Greenville's bustling areas, Harrington Trail is perfect for those who desire a blend of community and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments Near 29605",
      "seo_description": "Find four-bedroom apartments near 29605 at Harrington Trail, featuring spacious layouts and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartments-near-prisma-health-hillcrest-hospital",
      "search_query": "apartments near Prisma Health Hillcrest Hospital Greenville SC",
      "category": "Hospital",
      "h1_title": "Apartments Near Prisma Health Hillcrest Hospital",
      "h2_subtitle": "Live close to Prisma Health Hillcrest Hospital at Harrington Trail. Enjoy convenient access and a range of luxury amenities.",
      "page_copy": "Harrington Trail offers the perfect location for those seeking apartments near Prisma Health Hillcrest Hospital in Greenville, SC. Our community provides a peaceful setting just minutes away from this major healthcare facility, making it an ideal choice for healthcare professionals and patients alike.\n\nHere, you'll find a blend of comfort and convenience, with spacious closets, stainless steel appliances, and a fenced backyard. Families will love the playground, and our security deposit alternative adds flexibility to leasing options. Experience seamless access to work while enjoying a community crafted for modern living, right in the heart of Greenville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Prisma Health Hillcrest Hospital",
      "seo_description": "Discover Harrington Trail, where you can find apartments near Prisma Health Hillcrest Hospital with modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartments-near-conestee-park-greenville-sc",
      "search_query": "apartments near Conestee Park Greenville SC",
      "category": "Park",
      "h1_title": "Apartments Near Conestee Park in Greenville, SC",
      "h2_subtitle": "Enjoy nature with apartments near Conestee Park in Greenville, SC. Live close to green spaces and recreational activities at Harrington Trail.",
      "page_copy": "Experience the best of outdoor living at Harrington Trail, offering charming apartments near Conestee Park in Greenville, SC. Situated close to this scenic park, our community is perfect for those who enjoy hiking, bird watching, and family outings, providing easy access to miles of trails and nature.\n\nOur apartments combine natural beauty with modern comforts, featuring stainless steel appliances, spacious closets, and fenced backyards. Families can also take advantage of the onsite playground and a flexible security deposit alternative. Whether you're commuting to work or spending a day at the park, Harrington Trail provides the perfect base for an active, fulfilling lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Conestee Park in Greenville, SC",
      "seo_description": "Find your home near Conestee Park in Greenville, SC at Harrington Trail, offering modern amenities and close proximity to nature and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartments-close-to-southside-park-29605",
      "search_query": "apartments close to Southside Park 29605",
      "category": "Park",
      "h1_title": "Apartments Close to Southside Park 29605",
      "h2_subtitle": "Discover convenience and leisure at Harrington Trail, our apartments close to Southside Park in the 29605 area. Enjoy nearby recreational opportunities.",
      "page_copy": "Harrington Trail is the ideal choice for those seeking apartments close to Southside Park in the 29605 area. Our community offers easy access to this local gem, known for its sports fields, trails, and picnic areas. It’s an excellent location for families and outdoor enthusiasts alike.\n\nEnjoy modern living with our array of amenities, including stainless steel appliances, spacious closets, and a fenced backyard. Our playground ensures fun for the kids, and a security deposit alternative makes moving in easier. Embrace the vibrant mix of community and recreation right at your doorstep in Greenville, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Southside Park 29605",
      "seo_description": "Live near Southside Park in the 29605 area at Harrington Trail. Enjoy modern amenities and easy access to recreational activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartments-near-sunset-park-greenville-county",
      "search_query": "apartments near Sunset Park Greenville County",
      "category": "Park",
      "h1_title": "Apartments Near Sunset Park Greenville County",
      "h2_subtitle": "Find comfort and convenience with our apartments near Sunset Park in Greenville County, offering easy access to recreation and relaxation.",
      "page_copy": "Discover the comforts of Harrington Trail, where you'll find apartments near Sunset Park in Greenville County. This prime location offers a peaceful retreat with close proximity to outdoor activities and natural attractions that Sunset Park is known for.\n\nResidents enjoy an array of modern amenities such as stainless steel appliances, spacious closets, and a fenced backyard. Our security deposit alternative makes it easier to move in, while the playground provides families with added enjoyment. Bask in the blend of tranquility and accessibility that this community offers, right in the heart of Greenville County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sunset Park Greenville County",
      "seo_description": "Explore apartments near Sunset Park in Greenville County at Harrington Trail, featuring modern amenities and close park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167633",
      "source": "generator",
      "page_item_url": "apartment-living-near-conestee-park-parking-sc",
      "search_query": "apartment living near Conestee Park Parking SC",
      "category": "Park",
      "h1_title": "Apartment Living Near Conestee Park Parking SC",
      "h2_subtitle": "Enjoy hassle-free apartment living near Conestee Park Parking SC. Discover the perfect blend of nature and convenience at Harrington Trail.",
      "page_copy": "Harrington Trail offers an ideal setting for those seeking apartment living near Conestee Park Parking SC. Just a short drive away, this location provides easy access to the park's trails and scenic views, where you can enjoy hiking, picnicking, and more.\n\nOur apartments offer premium features like stainless steel appliances, spacious closets, and a private fenced backyard. Families appreciate the convenience of the onsite playground, and our security deposit alternative adds flexibility to your leasing options. Enjoy the best of both worlds with the serenity of nature and the convenience of nearby amenities at Harrington Trail.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Conestee Park Parking SC",
      "seo_description": "Embrace apartment living near Conestee Park Parking SC at Harrington Trail. Experience modern comfort and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977244674"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KCZ6D9MN"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57158638180"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow3m8jzv2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/c78955ab-4818-4dab-8b4a-898abca5b380/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5760f32-ff93-11ef-945c-737893ca6a84"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-528-6366"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "877-851-4773"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977244674",
  "custom_google_gtm_id": "GTM-KCZ6D9MN",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57158638180",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/gow3m8jzv2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/c78955ab-4818-4dab-8b4a-898abca5b380/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5760f32-ff93-11ef-945c-737893ca6a84",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "855-528-6366",
  "custom_paid_social_tracking_phone_number": "877-851-4773",
  "custom_audioeye_site_id": "9dd7774f-e934-482c-bdd9-0e2e53452593",
  "custom_audioeye_site_hash": "6b3108f0158c6f6f160373440ac9ecfc"
};

export const generatedAt = '2026-10-30T17:48:37.698Z';
